/** 航班類型 */
export enum BookFlightType {
  ONE_WAY = 'one-way',
  ROUND_TRIP = 'round-trip',
  MULTIPLE_CITY = 'multiple-city'
}
